import PropTypes from 'prop-types';

export const Props = {
  /**
   * The theme of the button
   */
  theme: PropTypes.oneOf([
    'default',
    'pitch',
    'white',
    'eggwhite',
    'light',
    'medium',
    'alpha',
    'alpha_light',
    'alpha_medium',
    'alpha_dark',
    'omega',
    'omega_light',
    'omega_medium',
    'omega_dark',
    'omega_pitch',
    'beta',
    'beta_medium',
    'beta_dark',
  ]),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
